// ============================================================
// Utilidades de notificaciones del navegador + sonido
// ============================================================

/** Solicita permiso de notificaciones del navegador (llamar una sola vez al montar) */
export const solicitarPermisoNotif = () => {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
};

/**
 * Dispara notificación nativa del navegador SOLO si la pestaña no está visible.
 * @param {string} titulo
 * @param {string} cuerpo
 */
export const fireNotifBrowser = (titulo, cuerpo) => {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (!document.hidden) return; // si el usuario ya está viendo la app, no molestar
  try {
    new Notification(titulo, {
      body: cuerpo,
      icon: '/icono-choyero.png',
      badge: '/icono-choyero.png',
      tag: 'choyero-chat', // evita duplicados si llegan varios mensajes seguidos
    });
  } catch (_) {}
};

/**
 * Reproduce un pitido suave de notificación usando Web Audio API (sin archivos externos).
 */
export const playNotifSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.setValueAtTime(660, ctx.currentTime + 0.12);
    gain.gain.setValueAtTime(0.25, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.35);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.35);
  } catch (_) {}
};

/**
 * Reproduce un sonido urgente de nueva orden (3 pitidos ascendentes, más fuerte).
 */
export const playOrdenSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const pitidos = [
      { freq: 600, inicio: 0 },
      { freq: 800, inicio: 0.25 },
      { freq: 1000, inicio: 0.5 },
    ];
    pitidos.forEach(({ freq, inicio }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'triangle';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + inicio);
      gain.gain.setValueAtTime(0.45, ctx.currentTime + inicio);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + inicio + 0.2);
      osc.start(ctx.currentTime + inicio);
      osc.stop(ctx.currentTime + inicio + 0.2);
    });
  } catch (_) {}
};

/**
 * Vibra el dispositivo con patrón de alerta urgente.
 */
export const vibrarOrden = () => {
  try {
    if ('vibrate' in navigator) {
      navigator.vibrate([400, 150, 400, 150, 600]);
    }
  } catch (_) {}
};

export const vibrarInicioViaje = () => {
  try { if ('vibrate' in navigator) navigator.vibrate(80); } catch (_) {}
};

export const vibrarPasoViaje = () => {
  try { if ('vibrate' in navigator) navigator.vibrate(80); } catch (_) {}
};

export const vibrarEntregaFinal = () => {
  try { if ('vibrate' in navigator) navigator.vibrate(80); } catch (_) {}
};

/**
 * Notificación del browser para nueva orden (visible incluso con la app en primer plano).
 */
export const fireNotifOrden = (titulo, cuerpo) => {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  try {
    new Notification(titulo, {
      body: cuerpo,
      icon: '/icono-choyero.png',
      badge: '/icono-choyero.png',
      tag: 'choyero-nueva-orden',
      requireInteraction: true, // se queda hasta que el chofer la cierre
    });
  } catch (_) {}
};
